const faqData = [
    {
        id: 0,
        category: 'General',
        question: '¿Cómo me comunico con LifeSafer?',
        answer: 'Nuestra sección de Ayuda le ofrece 3 opciones para ponerse en contacto con nosotros, ya sea por correo electrónico, teléfono o chat. ',
        internalLink: '/help',
        linkText:'Haga clic aquí y comience.'
    },
    {
        id: 1,
        category: 'General',
        question: '¿Cómo actualizo la información de mi identificación?',
        answer: 'Se puede acceder a la información de su identificación haciendo clic en el ícono de perfil en la esquina superior derecha del sitio y navegando a la pestaña Información del estado de su perfil. Luego, haga clic en la flecha junto a la información de identificación del estado para editar. ',
        internalLink: '/profile',
        linkText: 'Haga clic aquí para ir allí ahora.'
    },
    {
        id: 2,
        category: 'General',
        question: '¿Cómo puedo actualizar mi contraseña?',
        answer: 'Puede actualizar su contraseña haciendo clic en el ícono de perfil en la esquina superior derecha del sitio y luego haga clic en la flecha que indica la contraseña para actualizar. ',
        internalLink: '/profile',
        linkText: 'Haga clic aquí para actualizar ahora.'
    },
    {
        id: 3,
        category: 'General',
        question: '¿Cómo puedo actualizar mi dirección?',
        answer: 'Se puede acceder a su dirección haciendo clic en el ícono de perfil en la esquina superior derecha del sitio y navegando a la pestaña Información del estado de su perfil. Luego, haga clic en la flecha junto a la Dirección para editar. ',
        internalLink: '/profile',
        linkText: 'Haga clic aquí para ir allí ahora.'
    },
    {
        id: 4,
        category: 'General',
        question: 'Necesito que se realice el servicio en mi vehículo, ¿qué debo hacer para mantener el cumplimiento?',
        answer: 'Es importante que LifeSafer sepa sobre el servicio que se está realizando en su vehículo para que podamos asegurarnos de que su mecánico no solo esté listo para realizar el servicio, sino que lo mantenga en cumplimiento. ',
        externalLink: 'https://www.lifesafer.com/mechanic-states/',
        linkText:'Haga clic aquí para obtener el Formulario de declaración jurada para mecánicos de su estado.'
    },
    {
        id: 5,
        category: 'Dispositivo',
        question: '¿Dónde encuentro la información de mi dispositivo?',
        answer: 'Nuestra página de Tablero contiene la información de su dispositivo, haga clic en el icono de menú <span class="material-icons inline-icon"> account_circle </span> en la esquina superior derecha del mosaico y verá un enlace a la Guía del usuario de su dispositivo. ',
        internalLink: '/ ',
        linkText: 'Haga clic aquí para ir a su panel de control.'
    },
    {
        id: 6,
        category: 'Dispositivo',
        question: 'Mi dispositivo está bloqueado, ¿qué debo hacer?',
        answer: 'No se preocupe, podemos ayudarlo con su bloqueo, nuestra sección de Ayuda le ofrece 3 opciones para ponerse en contacto con nosotros por correo electrónico, teléfono o chat. ',
        internalLink: '/help',
        linkText: 'Haga clic aquí y comience.'
    },
    {
        id: 7,
        category: 'Pagos',
        question: '¿Cómo hago un pago?',
        answer: 'Hacer pagos es fácil dentro de su portal, la sección Pagos siempre le permite pagar cualquier saldo pendiente de la cuenta para que sepa que está al día. ',
        internalLink: '/payments',
        linkText: 'Haga clic aquí para revisar la información de su cuenta.'
    },
    {
        id: 8,
        category: 'Pagos',
        question: '¿Cómo me inscribo en Pago Automático?',
        answer: 'Dentro de la sección Pago del portal, puede agregar o actualizar un método de pago y seleccionarlo como su método de pago automático preferido. ',
        internalLink: '/payments',
        linkText: 'Haz clic para comenzar.'
    },
    {
        id: 9,
        category: 'Pagos',
        question: '¿Cómo puedo revisar mis Facturas?',
        answer: 'La sección Pago tiene información de factura disponible para todas sus citas de servicio durante su tiempo con LifeSafer. ',
        internalLink: '/payments',
        linkText: 'Haga clic aquí para revisar esas facturas ahora.'
    },
    {
        id: 10,
        category: 'Equipo',
        question: '¿Cómo programo, reprogramo o cancelo una cita de monitoreo o instalación?',
        answer: 'Para las citas de seguimiento e instalación las podemos atender en la sección de Citas del portal. ',
        internalLink: '/appointments',
        linkText: 'Haga clic aquí para actualizar su cita ahora.'
    },
    {
        id: 11,
        category: 'Equipo',
        question: '¿Dónde puedo obtener información sobre la desinstalación?',
        answer: 'Las reglas específicas de la región que rodean la desinstalación es algo que nuestro equipo de soporte experto puede guiarlo para que podamos ayudarlo a completar su programa con éxito. Nuestra sección de Ayuda le ofrece 3 opciones para ponerse en contacto con nosotros, ya sea por correo electrónico, teléfono o chat. ',
        internalLink: '/help',
        linkText: 'Haga clic aquí y comience.'
    },
]

export default faqData